// extracted by mini-css-extract-plugin
export default {"wrapper":"WizardLanguages_wrapper__1jyjf","section":"WizardLanguages_section__F0hqp"};